module.exports = __webpack_public_path__ + "static/media/contact_mail_black_24dp.79a434ed.svg";